"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyles = exports.ThemeProvider = void 0; // /<reference path="../../types/jss.d.ts"/>

/* eslint-disable @typescript-eslint/ban-types */

var jss_preset_2kit_1 = __importDefault(require("@mail/jss-preset-2kit"));

var jss_1 = __importDefault(require("jss"));

var PropTypes = __importStar(require("prop-types"));

var react_1 = __importDefault(require("react"));

var react_jss_1 = __importStar(require("react-jss"));

var theme_1 = require("../theme");

var decorators_1 = require("./decorators");

jss_1.default.setup(jss_preset_2kit_1.default());
var ThemeProviderContextTypes = {
  hasThemeProvider: PropTypes.bool
};

var ThemeProvider =
/** @class */
function (_super) {
  __extends(ThemeProvider, _super);

  function ThemeProvider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ThemeProvider.prototype.getChildContext = function () {
    return {
      hasThemeProvider: true
    };
  };

  ThemeProvider.prototype.render = function () {
    return react_1.default.createElement(react_jss_1.ThemeProvider, __assign({}, this.props));
  };

  ThemeProvider.childContextTypes = ThemeProviderContextTypes;
  return ThemeProvider;
}(react_1.default.Component);

exports.ThemeProvider = ThemeProvider;
/**
 * Фабрика декораторов для подключения jss стилей к компоненту
 *
 * В результате применения создаваемого декоратора
 * в свойства компонента подмешивается свойство classes
 * с картой соответствий исходных и сгенерированных CSS-классов
 *
 * @param styles описание jss-таблицы стилей
 * @genericParam C перечисление поддерживаемых компонентом CSS-классов
 * @genericParam P базовые (без св-ва) classes) свойства компонента
 * @return Декоратор для стилизуемого компонента
 */

exports.withStyles = function (styles) {
  return decorators_1.createDecorator(function (Component) {
    var _a;

    if (typeof styles !== 'function') {
      return react_jss_1.default(styles)(Component);
    }

    var ThemedComponent = react_jss_1.default(styles)(Component);
    var BaseComponent = react_jss_1.default(styles(theme_1.theme))(Component);
    var componentDisplayName = Component.displayName || Component.name ||
    /* istanbul ignore next */
    'Component'; // tslint:disable-next-line:max-classes-per-file

    return _a =
    /** @class */
    function (_super) {
      __extends(class_1, _super);

      function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
      }

      class_1.prototype.render = function () {
        return this.context.hasThemeProvider ? react_1.default.createElement(ThemedComponent, __assign({}, this.props)) : react_1.default.createElement(BaseComponent, __assign({
          theme: theme_1.theme
        }, this.props));
      };

      return class_1;
    }(react_1.default.Component), _a.displayName = "withStyles(" + componentDisplayName + ")", _a.contextTypes = ThemeProviderContextTypes, _a.NakedComponent = Component.NakedComponent || Component, _a;
  });
};